module.exports = __webpack_public_path__ + "img/62.e50c3c4e.png";